import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const home = () => {
    let tl = gsap.timeline();
  tl.to(".main-hero__heading-wrapper", {
    y: 0,
    opacity: 1,
    duration: 2,
    clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
    ease: "power4.out",
  }).from(".btn--hidden", {
      opacity:0,
      y: +100,
      duration: 0.5,
        ease: "power4.out",
        stagger: 0.1,
  }, "-=1");

  gsap.set(".hex", { opacity: 0 });

  ScrollTrigger.batch(".hex", {
    onEnter: (batch) => gsap.to(batch, { opacity: 1, stagger: 0.1 }),
  });
};

export default home;
